<template>
  <v-dialog
    :value="value"
    :max-width="$vuetify.breakpoint.xsOnly ? '100%' : '480'"
    aria-label="Keyboard shortcuts"
    @input="$emit('input', $event)"
    @keydown.esc="$emit('input', false)"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-keyboard</v-icon>
        Keyboard Shortcuts
        <v-spacer />
        <v-btn
          icon
          small
          :aria-label="$t('common.close')"
          @click="$emit('input', false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <div v-for="group in shortcutGroups" :key="group.title" class="mb-4">
          <div class="shortcut-group-title mb-2">{{ group.title }}</div>
          <div
            v-for="item in group.items"
            :key="item.key"
            class="shortcut-row d-flex align-center py-1"
          >
            <div class="shortcut-keys">
              <kbd v-for="(k, i) in item.keys" :key="i" class="shortcut-kbd">
                {{ k }}
              </kbd>
            </div>
            <div class="shortcut-desc grey--text text--darken-1">
              {{ item.desc }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ShortcutHelpDialog',
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      shortcutGroups: [
        {
          title: 'Global',
          items: [
            { keys: ['Ctrl', 'K'], desc: 'Open global search' },
            { keys: ['Ctrl', '/'], desc: 'Show this help' },
            { keys: ['?'], desc: 'Show this help' },
            { keys: ['Esc'], desc: 'Close dialog / search' },
          ],
        },
        {
          title: 'Table Views',
          items: [{ keys: ['R'], desc: 'Refresh table data' }],
        },
        {
          title: 'Navigation',
          items: [
            { keys: ['G', 'then', 'H'], desc: 'Go to Dashboard' },
            { keys: ['G', 'then', 'S'], desc: 'Go to Preferences' },
            { keys: ['G', 'then', 'M'], desc: 'Go to LBank Monitor' },
          ],
        },
      ],
    }
  },
}
</script>

<style scoped>
.shortcut-group-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
}

.shortcut-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.shortcut-keys {
  min-width: 140px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.shortcut-kbd {
  display: inline-block;
  padding: 2px 7px;
  font-size: 12px;
  font-family: 'SFMono-Regular', Consolas, monospace;
  color: #333;
  background: #f5f5f5;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
  line-height: 1.5;
}

.theme--dark .shortcut-kbd {
  color: #e0e0e0;
  background: #424242;
  border-color: #616161;
}

.theme--dark .shortcut-row {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}

.shortcut-desc {
  font-size: 13px;
}
</style>
